import { useState } from "react";
import ENGINEERING from "../../assets/png/ENGINEERING.png";
import MISSION from "../../assets/png/MISSION.png";
import INNOVATION from "../../assets/png/INNOVATION.png";
import VISION from "../../assets/png/ENGINEERING.jpg";

const DealerRoadmap = () => {
  const [activeTab, setActiveTab] = useState(0);
  const infoArray = ["MISSION", "VISION", "ENGINEERING", "INNOVATION"];
  const List = [
    {
      title: "EASY-TO-MAINTAIN",
      subTitle: "Empower Adventurers and Workers",
      dec: "Join us in revolutionizing the utility vehicle industry. Tuatara’s mission is to empower adventurers and workers across diverse terrains with easy-to-maintain, eco-friendly vehicles. By becoming a Tuatara dealer, you’re not only offering innovative, reliable utility vehicles but also contributing to a greener, more sustainable future.",
      img: MISSION,
    },
    {
      title: "GLOBAL NETWORK",
      subTitle: "Commitment to Sustainability and Innovation",
      dec: "As a Tuatara dealer, you will join a global network committed to promoting green initiatives and sustainable solutions. Our electric models are a standout in the market, offering zero emissions, long-lasting battery life, and the durability to tackle tough jobs. With our vision to empower customers worldwide, we are looking for dedicated partners who share our commitment to sustainability and innovation.",
      img: VISION,
    },
    {
      title: "ALL-STEEL CONSTRUCTION",
      subTitle: "Engineered to Out-Perform and Built to Last",
      dec: "To create a vehicle that’s built to last for decades, our engineers crafted an all-steel body, reinforced with industry-leading Electrophoresis Anti-Rust treatment. This isn’t your typical plastic UV—this is a purpose-driven machine, designed with a frame that can take on ever evolving terrain and adapt to perform challenging tasks.",
      img: ENGINEERING,
    },
    {
      title: "BECOME A LEADER",
      subTitle: "Foster Strategic Partnerships",
      dec: "At Tuatara we innovate and develop new gas, electric, and dual motor models to meet growing market demand for sustainable vehicles. We work with our dealer network to foster strategic partnerships to promote green initiatives in the utility vehicle industry.",
      img: INNOVATION,
    },
  ];
  return (
    <div className="relative">
      <div class="grid grid-cols-1 lg:grid-cols-7 gap-4">
        <div className="lg:col-span-5 col-span-1  custom-container py-[50px] md:px-[100px] px-[0px] lg:text-start text-center">
          <div className="lg:max-w-[900px] max-w-full">
            <div className="font-[Rockwell] text-[#292929] border-[#FFFFFF] border-b-[3px] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold mb-[15px]">
              DEALER ROADMAP
            </div>
            <div className="flex flex-wrap flex-col sm:flex-row">
              {infoArray.map((item, index) => {
                return (
                  <div
                    onClick={() => setActiveTab(index)}
                    className={`${
                      activeTab == index ? "text-[#292929]" : "text-[#fff]"
                    } cursor-pointer lg:mr-[60px] md:mr-[40px] mr-[10px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#292929] md:mt-[30px] sm:mt-[20px] mt-[10px] font-bold`}
                  >
                    <span
                      className={`${
                        activeTab == index
                          ? "lg:border-b-[5px] sm:border-b-[4px] border-b-[2px] border-[#292929] lg:pb-[12px] md:pb-[4px] pb-[0px]"
                          : ""
                      }`}
                    >
                      {item}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="font-[Roboto] 2xl:text-[46px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold text-[#000] lg:mt-[86px] md:mt-[66px] sm:mt-[46px] mt-[20px] text-[#292929]">
              {List?.[activeTab].title}
            </div>
            <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#292929]">
              {List?.[activeTab].subTitle}
            </div>
            <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#292929] lg:mt-[52px] md:mt-[42px] mt-[20px] lg:mb-[200px] md:mb-[100px] sm:mb-[50px] mb-[0px]">
              {List?.[activeTab].dec}
            </div>
          </div>
        </div>
        <div className="lg:col-span-2 col-span-1">
          <div
            className="ArielView1500E lg:min-h-[500px] md:min-h-[400px] sm:min-h-[250px] min-h-[200px]"
            style={{ backgroundImage: `url(${List?.[activeTab].img})` }}
          />
        </div>
      </div>

      <div className="bg-[#292929] py-[66px] " style={{ boxShadow: "0px 4px 4px 0px #29292900040" }}>
        <div className="custom-container">
          <div className="flex items-center justify-between flex-wrap">
            <div>
              <div className="lg:text-[38px] md:text-[35px] sm:text-[20px] text-[#292929] text-[Roboto] text-[#7ABF5B] font-bold lg:pb-[28px] md:pb-[18px] pb-[10px]">
                READY TO BECOME A TUATARA DEALER?
              </div>
              <div className="font-[Roboto] lg:text-[26px] md:text-[26px] sm:text-[16px]  text-[16px] text-[#F2F2F2] lg:pb-[0px] md:pb-[18px] pb-[10px]">
                Inquire today to join our network of innovative dealers.
              </div>
            </div>
            <div>
              <button
                className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] lg:text-[26px] md:text-[26px] sm:text-[16px]  text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold  lg:px-[50px] md:px-[70px] sm:px-[20px] px-[10px] flex items-center"
                style={{ boxShadow: "0px 4px 4px 0px #29292900040" }}
              >
                NEW DEALER INQUIRY FORM
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DealerRoadmap;
